import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface ISearchResultNotFoundProps {
  width: string;
  searchWord: string;
  clearSearch: () => void;
}

export const SearchResultNotFound: React.FC<ISearchResultNotFoundProps> = ({
  width,
  searchWord,
  clearSearch,
}) => {
  return (
    <SearchResultNotFoundWrapper width={width}>
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage='Your search for "{searchWordCompanyName}" did not match any recent orders.'
          values={{
            searchWordCompanyName: searchWord,
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Button variant="tertiary" onClick={clearSearch}>
        <StrictLocalMsg
          defaultMessage="Clear search"
          description={{
            text: "Button to clear the search input",
          }}
        />
      </Button>
    </SearchResultNotFoundWrapper>
  );
};

const SearchResultNotFoundWrapper = styled(Column).attrs({
  align: { desktopAndAbove: "center", mobileAndAbove: "flex-start" },
  justify: "center",
})<{
  width: string;
}>`
  padding: ${getSpacing("2x")};
  width: ${(props) => props.width ?? "100%"};
  height: 130px;
  background-color: ${Core.surface.subdued};
`;
